import 'css-chunksrc/client/pages/projectPage/synthesisPage/tasksLoader/styles.scss';export default {
  "task": "_task_5mkg7_1",
  "nameBox": "_nameBox_5mkg7_8",
  "name": "_name_5mkg7_8",
  "statusBox": "_statusBox_5mkg7_17",
  "status": "_status_5mkg7_17",
  "endDateBox": "_endDateBox_5mkg7_26",
  "endDate": "_endDate_5mkg7_26"
};